import {
  getLoggingActions,
  LoginTypeEnum,
  logoutAuthUser,
  preserveTableColumn,
  setForceMsalPromptNextLogin,
  showLoader,
  UserTypeEnum,
} from '@app-store'
import type { Persistor } from 'redux-persist'
import { AUTH_PROVIDER, getLoginCredentials } from '../utils/constants'
import { clearMsalAppSessionOnly } from '../utils/msalConfig'
import { clearMsalAccessTokenBridge } from '@ecrm-msal'
import {
  getPostLogoutCapturePath,
  setSessionPostLogoutReturnPath,
} from '../utils/postLogoutReturnPath'
import { broadcastForceLogout } from '@ecrm-session'
import type { AppDispatch } from '../utils/agent.store'

export async function performAgentDeskLogout(params: {
  dispatch: AppDispatch
  persist: Persistor
  token: string | null
  loginType: LoginTypeEnum
  /** Broadcast to other tabs (default true). */
  broadcastCrossTab?: boolean
  invalidateToken?: () => Promise<void>
}): Promise<void> {
  const {
    dispatch,
    persist,
    token,
    loginType,
    broadcastCrossTab = true,
    invalidateToken,
  } = params

  if (broadcastCrossTab) {
    broadcastForceLogout(loginType)
  }

  if (token) {
    await getLoggingActions(token, loginType, UserTypeEnum.AGENT)
  }

  preserveTableColumn(persist)

  setSessionPostLogoutReturnPath(getPostLogoutCapturePath())

  const authProvider = getLoginCredentials().authProvider

  if (authProvider === AUTH_PROVIDER.MSAL) {
    dispatch(showLoader())
    await clearMsalAppSessionOnly()
    clearMsalAccessTokenBridge()
    await invalidateToken?.()
    dispatch(logoutAuthUser())
    dispatch(setForceMsalPromptNextLogin(true))
    await persist.flush()
    window.location.href = `${window.location.origin}/logout?forceMsalPromptNextLogin=1`
  } else {
    dispatch(logoutAuthUser())
    await persist.flush()
    window.location.href = `${window.location.origin}/logout`
  }
}
